/**
 * mobile-page-title.js
 */

import React from 'react';
import { useMediaQuery } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {
  Typography,
} from '@mui/material';


const useStyles = makeStyles(theme => ({
  container: {
    padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
    backgroundColor: theme.palette.sys.surfaceContainerHighest,
    display: 'flex',
    justifyContent: props => Boolean(props.rightAction) ? 'space-between' : 'center',
    fontWeight: 600,
    fontSize: theme.typography.sizes[2],
    '& > *': {
      width: 88,
      whiteSpace: 'nowrap',
    },
    '& .title': {
      width: 'auto',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& .skip': {
      paddingLeft: theme.spacing(1),
      textAlign: 'right',
      '& .MuiButton-root': {
        fontSize: theme.typography.sizes[1],
        fontWeight: theme.typography.fontWeightBold,
        color: theme.palette.primary.main,
        padding: 0,
      },
      '& .MuiButton-endIcon': {
        marginLeft: 0,
      },
    }
  },
}));

export default function MobilePageTitle(props) {
  const { title, rightAction, ...rest } = props;
  const classes = useStyles({rightAction});
  const isMobileDrawer = useMediaQuery(theme => theme.breakpoints.down('sm_md'), { noSsr: true });

  return isMobileDrawer
    ? (
      <Typography variant='h6' className={classes.container} {...rest}>
        <div className='title' data-testid='mobile-drawer-content-title'>{title}</div>
        {rightAction && <div className='skip'>{rightAction}</div>}
      </Typography>
    ) : null;
}

